import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import './index.css'
import App from './App.jsx'
import { config } from '@config'
import monitoringService from '@services/monitoring'
import { msalConfig } from '@config/auth'; // Import MSAL config
import { debug } from '@utils/debug'; // Import debug utility

// Initialize Application Insights if configured
if (config.monitoring.applicationInsights.enabled) {
  monitoringService.init(config.monitoring.applicationInsights.connectionString);
  debug('main', 'Application Insights monitoring initialized');
}

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Wrap the rendering logic in an async function to await initialization
const renderApp = async () => {
  try {
    debug('main', 'Initializing MSAL...');
    await msalInstance.initialize();
    debug('main', 'MSAL initialized successfully.');

    createRoot(document.getElementById('root')).render(
      <StrictMode>
        <BrowserRouter>
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </BrowserRouter>
      </StrictMode>,
    );
  } catch (error) {
    debug('main:error', 'MSAL initialization failed:', error);
    // Optionally render an error message to the user
  }
};

renderApp();
